import React from 'react';
import { NumberField } from 'components/UI/V3/Forms/NumberField/NumberField';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import styles from './DurationSection.module.scss';

interface DurationSectionProps {
    hours: number;
    minutes: number;
    onHoursChange: (hours: number) => void;
    onMinutesChange: (minutes: number) => void;
    error?: string;
}

export const DurationSection: React.FC<DurationSectionProps> = ({
    hours,
    minutes,
    onHoursChange,
    onMinutesChange,
    error
}) => {
    const handleHoursChange = (value: number | undefined) => {
        const numValue = value || 0;
        // Limit to reasonable hours (0-10)
        if (numValue >= 0 && numValue <= 10) {
            onHoursChange(numValue);
        }
    };

    const handleMinutesChange = (value: number | undefined) => {
        const numValue = value || 0;
        // Limit to 0-59 minutes
        if (numValue >= 0 && numValue < 60) {
            onMinutesChange(numValue);
        }
    };

    return (
        <div className={styles.container}>
            <Label required>Duration</Label>

            <div className={styles.fieldsContainer}>
                <div className={styles.field}>
                    <NumberField
                        value={hours}
                        onChange={handleHoursChange}
                        placeholder="0"
                        scale={0}
                        precision={2}
                        alignRight={false}
                        className={styles.numberInput}
                    />
                    <span className={styles.label}>Hours</span>
                </div>

                <div className={styles.field}>
                    <NumberField
                        value={minutes}
                        onChange={handleMinutesChange}
                        placeholder="0"
                        scale={0}
                        precision={2}
                        alignRight={false}
                        className={styles.numberInput}
                    />
                    <span className={styles.label}>Minutes</span>
                </div>
            </div>

            {error && <span className={styles.error}>{error}</span>}
        </div>
    );
};
